__turbopack_context__.v({
  "coinWrapper": "BottomBarClient-module-scss-module__6fSTFG__coinWrapper",
  "hotIcon": "BottomBarClient-module-scss-module__6fSTFG__hotIcon",
  "reply": "BottomBarClient-module-scss-module__6fSTFG__reply",
});
